import { Container } from "../injection";
import { createBridge } from "./createBridge";
import { TimeoutNotice } from "../messageBus/TimeoutNotice";
import { ErrorDisplay } from "../error/ErrorDisplay";
import { TestBridge } from "../../features/testBridge/TestBridge";
import { LazySecuritiesApiMultiSelectAutoUpdateBridge } from "../../features/select/securities/securitiesApiMultiSelectAutoUpdate/LazySecuritiesApiMultiSelectAutoUpdateBridge";
import { LazyContactsApiMultiSelectAutoUpdateBridge } from "../../features/select/contacts/contactsApiMultiSelectAutoUpdate/LazyContactsApiMultiSelectAutoUpdateBridge";
import { LazyUsersMultiSelectAutoUpdateBridge } from "../../features/select/users/multiSelect/usersMultiSelectAutoUpdate/LazyUsersMultiSelectAutoUpdateBridge";
import { LazyTradersMultiSelectAutoUpdateBridge } from "../../features/select/traders/tradersMultiSelectAutoUpdate/LazyTradersMultiSelectAutoUpdateBridge";
import { LazyFundsMultiSelectAutoUpdateBridge } from "../../features/select/funds/fundsMultiSelectAutoUpdate/LazyFundsMultiSelectAutoUpdateBridge";
import { LazyBrokersMultiSelectAutoUpdateBridge } from "../../features/select/brokers/brokersMultiSelectAutoUpdate/LazyBrokersMultiSelectAutoUpdateBridge";
import { LazyAssetTypesSingleSelectAutoUpdateBridge } from "../../features/select/assetTypes/assetTypesSingleSelectAutoUpdate/LazyAssetTypesSingleSelectAutoUpdateBridge";
import { LazyResearchEvaluationBridge } from "../../features/researchEvaluation/LazyResearchEvaluationBridge";
import { LazyRedBoxPaletteInsertBridge } from "../../features/redBoxVoiceCall/LazyPaletteInsertBridge";
import { LazyRedBoxPlayerBridge } from "../../features/redBoxVoiceCall/LazyPlayerBridge";
import { LazyMicrosoftTeamsCallPaletteInsertBridge } from "../../features/microsoftTeamsCall/LazyPaletteInsertBridge";
import { LazyMicrosoftTeamsCallPlayerBridge } from "../../features/microsoftTeamsCall/LazyPlayerBridge";
import { LazyWormIBChatViewerBridge } from "../../features/chatViewer/LazyWormIBChatViewerBridge";
import { LazyWormMicrosoftTeamsViewerBridge } from "../../features/chatViewer/LazyWormMicrosoftTeamsViewerBridge";
import { LazyWormSlackViewerBridge } from "../../features/chatViewer/LazyWormSlackViewerBridge";
import { LazyNumberInputWithErrorBridge } from "../../features/numberInput/LazyNumberInputWithErrorBridge";
import {
    LazyFeedSelectionControlBridge,
    LazyCaseResultsSummaryBridge,
    LazyCaseLogExpand,
    LazyOwnershipControl,
    LazyCaseLogList
} from "../../features/casePage/LazyCaseInsertBridges";
import { LazySelectBridge } from "../../features/select/LazySelectBridge";
import { LazyFeedPresetGroupSelectorBridge } from "../../features/feed/feedPresetGroupSelector/LazyFeedPresetGroupSelectorBridge";
import { LazyEmailThreadPopupBridge } from "../../features/emailThreadPopup/LazyEmailThreadPopupBridge";
import { LazyMeetingThreadPopupBridge } from "../../features/meetingThreadPopup/LazyMeetingThreadPopupBridge";
import { LazyFeedTileHoverBridge } from "../../features/feed/feedTileHover/LazyFeedTileHoverBridge";
import { LazySystemMonitorResultPaletteInsertBridge } from "../../features/systemMonitor/LazyResultPaletteInsertBridge";
import {
    LazyDateTimePicker,
    LazyStringDateTimePicker
} from "../../uiLibrary/dateTimePicker/Lazy";
import { LazyTimeSince } from "../../uiLibrary/timeSince/LazyTimeSince";
import { LazyUserCircleSelect } from "../../uiLibrary/userCircleSelect/LazyUserCircleSelect";
import { LazyReviewInducementScan } from "../../features/monitorInducement/LazyReviewInducementScan";
import { LazyAuditLog } from "../../features/auditLog/LazyAuditLog";
import {
    LazyRulesPolicyOwnership,
    LazyAddRuleButton,
    LazyLogicRulesList,
    LazyImportRulesButton
} from "../../features/rulesPolicy/Lazy";
import {
    LazyCustomFieldGrouping,
    LazyCustomFields,
    LazyCustomFieldSelect,
    LazyCustomFieldValue
} from "../../features/surveillanceRuleToken/CustomFields/LazyCustomFields";
import { LazyBulkStatusChangePopup } from "../../features/casesOverviewPage/LazyBulkStatusChangePopup";
import { LazyLexiconPage } from "../../features/lexicons/LazyLexiconPage";
import { LazyWormCallPaletteInsert } from "../../features/wormCall/LazyPaletteInsert";
import { LazyCasePageChart } from "../../features/casePage/LazyCasePageChart";
import { LazyCaseTagMultiSelect } from "../../features/select/caseTags/LazyCaseTagMultiSelect";
import { LazyCasesCountBarChart } from "../../features/ideaGenBacktest/casesCountBarChart/LazyCasesCountBarChart";
import { LazyQueryStringWidgetEditInsert } from "@/features/feed/queryStringWidget/LazyQueryStringWidgetBridges";
import { LazyEditor, LazyEditorDisplay } from "../../uiLibrary/editor/Lazy";

export const createBridges = (container: Container) => {
    createBridge("test", TestBridge, container);
    createBridge("messageBus/timeoutNotice", TimeoutNotice, container);
    createBridge("error/errorDisplay", ErrorDisplay, container);
    createBridge(
        "marCase/securitiesApiMultiSelectAutoUpdate",
        LazySecuritiesApiMultiSelectAutoUpdateBridge,
        container
    );
    createBridge(
        "marCase/contactsApiMultiSelectAutoUpdate",
        LazyContactsApiMultiSelectAutoUpdateBridge,
        container
    );
    createBridge(
        "marCase/usersMultiSelectAutoUpdate",
        LazyUsersMultiSelectAutoUpdateBridge,
        container
    );
    createBridge(
        "marCase/tradersMultiSelectAutoUpdate",
        LazyTradersMultiSelectAutoUpdateBridge,
        container
    );
    createBridge(
        "marCase/fundsMultiSelectAutoUpdate",
        LazyFundsMultiSelectAutoUpdateBridge,
        container
    );
    createBridge(
        "marCase/brokersMultiSelectAutoUpdate",
        LazyBrokersMultiSelectAutoUpdateBridge,
        container
    );
    createBridge(
        "marCase/assetTypesSingleSelectAutoUpdate",
        LazyAssetTypesSingleSelectAutoUpdateBridge,
        container
    );

    createBridge("researchEvaluation", LazyResearchEvaluationBridge, container);

    createBridge(
        "redBoxVoiceCall/paletteInsert",
        LazyRedBoxPaletteInsertBridge,
        container
    );
    createBridge("redBoxVoiceCall/player", LazyRedBoxPlayerBridge, container);

    createBridge(
        "microsoftTeamsCall/paletteInsert",
        LazyMicrosoftTeamsCallPaletteInsertBridge,
        container
    );
    createBridge(
        "microsoftTeamsCall/player",
        LazyMicrosoftTeamsCallPlayerBridge,
        container
    );

    createBridge(
        "chatViewer/wormIBChatViewer",
        LazyWormIBChatViewerBridge,
        container
    );
    createBridge(
        "chatViewer/wormMicrosoftTeamsViewer",
        LazyWormMicrosoftTeamsViewerBridge,
        container
    );
    createBridge(
        "chatViewer/wormSlackViewer",
        LazyWormSlackViewerBridge,
        container
    );

    createBridge(
        "numberInput/numberInputWithError",
        LazyNumberInputWithErrorBridge,
        container
    );

    createBridge(
        "surveillance/casePage/feedSelectionControl",
        LazyFeedSelectionControlBridge,
        container
    );
    createBridge(
        "surveillance/casePage/caseResultsSummary",
        LazyCaseResultsSummaryBridge,
        container
    );
    createBridge(
        "surveillance/casePage/caseLogExpand",
        LazyCaseLogExpand,
        container
    );
    createBridge(
        "surveillance/casePage/caseLogList",
        LazyCaseLogList,
        container
    );
    createBridge(
        "surveillance/casePage/ownershipControl",
        LazyOwnershipControl,
        container
    );
    createBridge(
        "surveillance/casePage/caseTagMultiSelect",
        LazyCaseTagMultiSelect,
        container
    );
    createBridge("surveillance/casePage/chart", LazyCasePageChart, container);

    createBridge(
        "ideaGenBacktest/casesCountBarChart",
        LazyCasesCountBarChart,
        container
    );

    createBridge(
        "surveillance/casesOverviewPage/bulkStatusChangePopup",
        LazyBulkStatusChangePopup,
        container
    );

    createBridge("auditLog", LazyAuditLog, container);

    createBridge("rulesPolicy/ownership", LazyRulesPolicyOwnership, container);
    createBridge("rulesPolicy/addRuleButton", LazyAddRuleButton, container);
    createBridge("rulesPolicy/logicRulesList", LazyLogicRulesList, container);
    createBridge(
        "rulesPolicy/importRulesButton",
        LazyImportRulesButton,
        container
    );

    createBridge("select", LazySelectBridge, container);

    createBridge(
        "feed/presetGroupSelector",
        LazyFeedPresetGroupSelectorBridge,
        container
    );
    createBridge("feed/tileHover", LazyFeedTileHoverBridge, container);

    createBridge(
        "feed/queryStringWidget/editInsert",
        LazyQueryStringWidgetEditInsert,
        container
    );

    createBridge(
        "emailThreadPopup/emailThreadPopup",
        LazyEmailThreadPopupBridge,
        container
    );
    createBridge(
        "meetingThreadPopup/meetingThreadPopup",
        LazyMeetingThreadPopupBridge,
        container
    );

    createBridge(
        "systemMonitor/resultPaletteInsert",
        LazySystemMonitorResultPaletteInsertBridge,
        container
    );

    createBridge("stringDateTimePicker", LazyStringDateTimePicker, container);
    createBridge("dateTimePicker", LazyDateTimePicker, container);

    createBridge("timeSince", LazyTimeSince, container);

    createBridge("userCircleSelect", LazyUserCircleSelect, container);

    createBridge("reviewInducementScan", LazyReviewInducementScan, container);

    createBridge(
        "surveillanceRuleToken/customFields",
        LazyCustomFields,
        container
    );
    createBridge(
        "surveillanceRuleToken/customFieldGrouping",
        LazyCustomFieldGrouping,
        container
    );
    createBridge(
        "surveillanceRuleToken/customFieldSelect",
        LazyCustomFieldSelect,
        container
    );
    createBridge(
        "surveillanceRuleToken/customFieldValue",
        LazyCustomFieldValue,
        container
    );

    createBridge("lexicon/page", LazyLexiconPage, container);

    createBridge(
        "wormCall/paletteInsert",
        LazyWormCallPaletteInsert,
        container
    );

    createBridge("editor", LazyEditor, container);
    createBridge("editorDisplay", LazyEditorDisplay, container);
};
